import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { type LanguageCode } from 'js/common/LocaleSelector';
import { initReactI18next } from 'react-i18next';
import packageJson from '../../../package.json';
const isDev = process.env.NODE_ENV !== 'production';

export const initI18n = (staticPath: string = '') => {
    const htmlEl = document.querySelector('html');
    const locale = (htmlEl?.getAttribute('lang') as LanguageCode) || 'ko';

    i18n.use(HttpBackend)
        .use(initReactI18next)
        .init({
            debug: isDev,
            lng: locale,
            fallbackLng: false,
            supportedLngs: ['ko', 'en'],
            partialBundledLanguages: true,
            backend: {
                loadPath: `${isDev ? '' : staticPath + '/plaync/gameinfo/' + packageJson.version}/locales/${locale}.json`,
            },
        });
};
